import * as React from "react";
import logoImage from "../../assets/ekfc-logo-header.png";

export const PageTemplate = (props) => {
  return (
    <div>
      {props.pageNum === 1 && (
        <div
          style={{
            position: "absolute",
            top: "40px",
            left: "40px",
          }}
        >
          <img
            src={logoImage}
            alt="quality report header logo"
            style={{ maxHeight: "60px" }}
          />
        </div>
      )}
      {props.pageNum === 1 && (
        <div
          style={{
            position: "absolute",
            top: "35px",
            right: "40px",
            fontSize: "20px",
          }}
        >
          <p>Quality Report</p>
        </div>
      )}
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          left: "10px",
        }}
      >
        Page {props.pageNum} of {props.totalPages}
      </div>
    </div>
  );
};
